import React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import NoProductData from "./no-product-data";
import UserProductsDataGrid from "./UserProductsDataGrid";
import { useUserProducts } from "../hooks/use-user-products";

/**
 * Registered devices tab. Fetches once here and passes the rows down; the grid
 * used to issue the same query again on its own.
 */
const UserProducts: React.FC = () => {
  const { products, loading, error, reload } = useUserProducts();

  if (loading) {
    return (
      <Box>
        <Skeleton variant="rectangular" height={44} sx={{ mb: 2, borderRadius: 999, maxWidth: 200 }} />
        <Skeleton variant="rectangular" height={320} sx={{ borderRadius: 2 }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={reload}>
            Retry
          </Button>
        }
      >
        Could not load your registered devices.
      </Alert>
    );
  }

  if (products.length === 0) return <NoProductData />;

  return <UserProductsDataGrid products={products} onChanged={reload} />;
};

export default UserProducts;
